module.exports = __webpack_public_path__ + "e6833e9bcffefc67e70ae8aa28471f5c.svg";